import { z } from "@/helpers/forms/zod";

export const orderDetailsAddQuoteFormPageSchema = z.object({
  quoteNumber: z.string().min(1),
  totalPrice: z.number().gte(0),
  fileSignedId: z.string(),
  sandboxItemIds: z.array(z.string()).min(1),
});

export type InferredOrderDetailsAddQuoteFormPageSchema = z.infer<
  typeof orderDetailsAddQuoteFormPageSchema
>;
